/**
 * Debug wrapper for localStorage to track auth-storage writes
 */

// Store original localStorage methods
const originalSetItem = localStorage.setItem.bind(localStorage);
const originalRemoveItem = localStorage.removeItem.bind(localStorage);
const originalClear = localStorage.clear.bind(localStorage);

// Override setItem to track auth-storage writes
localStorage.setItem = function(key: string, value: string) {
  if (key === 'auth-storage') {
    console.log('🔍 [LocalStorage Debug] setItem called for auth-storage');
    console.log('  Value type:', typeof value);
    console.log('  Value (first 100):', String(value).substring(0, 100));
    console.log('  Stack trace:', new Error().stack);

    // Check if value is actually an object being coerced to string
    if (typeof value !== 'string') {
      console.error('❌ [LocalStorage Debug] NON-STRING value passed to setItem!');
      console.error('  Actual value:', value);
    }
  }

  return originalSetItem(key, value);
};

// Override removeItem to track auth-storage removals
localStorage.removeItem = function(key: string) {
  if (key === 'auth-storage') {
    console.log('🗑️ [LocalStorage Debug] removeItem called for auth-storage');
    console.log('  Stack trace:', new Error().stack);
  }

  return originalRemoveItem(key);
};

// Override clear to track localStorage clearing
localStorage.clear = function() {
  console.error('💣 [LocalStorage Debug] CLEAR CALLED - ALL STORAGE WILL BE ERASED!');
  console.error('  Stack trace:', new Error().stack);
  return originalClear();
};

// Monitor location.href changes
const originalHref = window.location.href;
const hrefDescriptor = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
if (hrefDescriptor && hrefDescriptor.set) {
  const originalHrefSetter = hrefDescriptor.set;
  Object.defineProperty(Location.prototype, 'href', {
    set: function(value) {
      console.error('🌐 [Navigation Debug] location.href CHANGED!');
      console.error('  From:', window.location.href);
      console.error('  To:', value);
      console.error('  Stack trace:', new Error().stack);
      return originalHrefSetter.call(this, value);
    },
    get: hrefDescriptor.get,
    configurable: true
  });
}

export {};
